module.exports = __webpack_public_path__ + "static/media/preloader.3c97d81a.mp4";